import SettlementList from './settlement.vue'
export default SettlementList
